var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _path11, _path12, _g2, _path13, _path14, _path15, _path16, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgThanksAllSet = function SvgThanksAllSet(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 204,
    viewBox: "0 0 201 204",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5341 25.0737C19.5876 26.7803 26.1297 76.2729 42.9117 70.8686C55.9959 66.7442 43.3383 23.3671 31.5341 25.0737Z",
    fill: "#FACFE2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.371 74.1443C1.09994 77.2731 34.6639 98.6061 38.9305 89.6463C44.6193 77.4154 8.21094 70.3044 4.371 74.1443Z",
    fill: "#FACFE2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1513 31.333C76.4759 25.2176 49.3119 52.9505 61.5428 65.7503C61.9695 66.177 62.6806 66.8881 63.1072 67.1725C77.7559 78.1234 91.2668 35.7419 85.1513 31.333Z",
    fill: "#FACFE2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4679 99.1717C62.681 94.4784 47.7479 58.4967 34.237 60.4878C20.1572 62.4789 25.5616 105.145 46.4679 99.1717Z",
    fill: "#FCE6EF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1475 62.7627C74.6272 63.0472 68.7962 4.45249 55.4275 2.74584C41.3477 1.0392 26.1301 62.4783 54.1475 62.7627Z",
    fill: "#FCE6EF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5079 105C39.7834 102.298 31.2502 95.6138 21.8637 97.4627C11.6239 99.4537 2.52178 112.111 4.0862 115.24C6.36172 119.791 29.9702 114.529 37.5079 105Z",
    fill: "#FCE6EF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4277 14.2687C55.4277 13.6999 55.001 13.2732 54.4322 13.2732C53.8633 13.2732 53.4366 13.6999 53.4366 14.2687L52.8677 119.369C52.4411 118.089 52.0144 116.952 51.4455 115.814C46.3256 91.6365 37.3657 68.8812 37.2235 68.4546C37.0813 67.8857 36.5124 67.7435 35.9435 67.8857C35.3747 68.0279 35.2324 68.5968 35.3747 69.1657C35.5169 69.4501 43.1968 88.7921 48.3167 110.552C46.8945 108.845 45.3301 107.281 43.4812 106.143C36.0858 101.45 26.9837 102.872 20.5838 104.863C20.0149 105.005 19.7304 105.574 19.8727 106.143C20.0149 106.712 20.5838 106.996 21.1527 106.854C27.1259 105.005 35.6591 103.583 42.3434 107.85C45.3301 109.698 47.7478 112.543 49.4545 116.383C51.1611 124.347 52.2988 132.596 52.5833 140.133V147.813H54.5744C54.7166 145.396 54.7166 142.836 54.5744 140.133L55.4277 14.2687Z",
    fill: "#FACFE2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3169 121.93C45.4725 120.081 42.9125 121.219 42.7703 121.219C42.3436 121.504 42.0592 122.072 42.2014 122.499C42.4859 123.068 43.0547 123.21 43.4814 123.068C43.6236 123.068 45.188 122.357 47.1791 123.637C49.3124 125.059 53.0102 130.179 52.5835 147.814C52.5835 148.383 53.0101 148.81 53.579 148.81C54.1479 148.81 54.5746 148.383 54.5746 147.814C55.0012 133.592 52.8679 124.917 48.3169 121.93Z",
    fill: "#FAAACE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7833 151.368L62.3968 182.799C62.1123 183.936 60.9746 184.79 59.6946 184.79H46.3259C45.0459 184.79 43.9082 183.936 43.6237 182.656L35.6594 151.226C35.2327 149.519 36.5127 147.67 38.3616 147.67H69.0811C70.93 147.67 72.3522 149.519 71.7833 151.368Z",
    fill: "#FAAACE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4191 122.922C14.3259 130.317 10.3438 152.361 16.8859 153.926C21.5792 155.064 27.1257 144.824 41.2055 134.726C50.4498 128.184 43.7655 110.691 25.4191 122.922Z",
    fill: "#FCE6EF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_31409_1062)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.7969,
    y: 48.7471,
    width: 104.639,
    height: 136.107,
    rx: 5.1093,
    fill: "url(#paint0_linear_31409_1062)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.9008,
    y: 58.9629,
    width: 84.431,
    height: 115.675,
    fill: "#E8EAFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.0388,
    y: 35.0703,
    width: 22.155,
    height: 19.594,
    rx: 2.55,
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.6595,
    y: 45.6992,
    width: 42.9137,
    height: 17.0543,
    rx: 2.55465,
    fill: "#DEDEDE"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M107.632 148.662C125.229 148.662 139.494 134.397 139.494 116.8C139.494 99.2027 125.229 84.9375 107.632 84.9375C90.0345 84.9375 75.7693 99.2027 75.7693 116.8C75.7693 134.397 90.0345 148.662 107.632 148.662Z",
    fill: "url(#paint1_linear_31409_1062)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M123.387 107.677L102.127 128.937L91.8761 118.686",
    stroke: "white",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_31409_1062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.189 155.241L130.112 140.526C128.998 135.203 133.629 130.446 138.981 131.416L154.245 134.185L133.189 155.241Z",
    fill: "#FCE1BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.485 142.313L128.947 134.956C128.39 132.294 130.706 129.915 133.381 130.401L141.014 131.785L130.485 142.313Z",
    fill: "#7E7EF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.3,
    y: 155.351,
    width: 29.7782,
    height: 59.3058,
    transform: "rotate(-45 133.3 155.351)",
    fill: "#ACAFFA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.494,
    y: 149.157,
    width: 12.2601,
    height: 59.3058,
    transform: "rotate(-45 139.494 149.157)",
    fill: "#D9DBFC"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M156.418 17.942C156.577 17.4682 157.297 17.4682 157.455 17.942C158.178 20.0958 159.572 23.8527 161.107 25.8701C162.766 28.0498 165.969 30.0133 167.51 30.8804C167.868 31.0816 167.868 31.6191 167.51 31.8202C165.969 32.6874 162.766 34.6509 161.107 36.8306C159.572 38.848 158.178 42.6049 157.455 44.7587C157.297 45.2324 156.577 45.2324 156.418 44.7587C155.696 42.6049 154.302 38.848 152.767 36.8306C151.108 34.6509 147.904 32.6874 146.363 31.8202C146.006 31.6191 146.006 31.0816 146.363 30.8804C147.904 30.0133 151.108 28.0498 152.767 25.8701C154.302 23.8527 155.696 20.0958 156.418 17.942Z",
    fill: "#FFEED4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M173.605 41.0346C173.771 40.5634 174.502 40.5634 174.668 41.0346C175.164 42.4382 175.953 44.4133 176.812 45.5411C177.775 46.8069 179.55 47.959 180.611 48.5786C180.966 48.7854 180.966 49.3276 180.611 49.5345C179.55 50.1541 177.775 51.3062 176.812 52.5719C175.953 53.6997 175.164 55.6749 174.668 57.0784C174.502 57.5496 173.771 57.5496 173.605 57.0784C173.109 55.6749 172.32 53.6997 171.461 52.5719C170.498 51.3062 168.723 50.1541 167.662 49.5345C167.307 49.3276 167.307 48.7854 167.662 48.5786C168.723 47.959 170.498 46.8069 171.461 45.5411C172.32 44.4133 173.109 42.4382 173.605 41.0346Z",
    fill: "#FCE1BB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0256 140.644C71.1847 140.17 71.904 140.17 72.0631 140.644C72.7746 142.762 74.1367 146.423 75.6358 148.393C77.2575 150.524 80.3845 152.444 81.9024 153.3C82.2598 153.501 82.2598 154.038 81.9024 154.24C80.3845 155.095 77.2575 157.015 75.6358 159.146C74.1367 161.117 72.7746 164.777 72.0631 166.895C71.904 167.369 71.1847 167.369 71.0256 166.895C70.3142 164.777 68.9521 161.117 67.4529 159.146C65.8313 157.015 62.7043 155.095 61.1864 154.24C60.829 154.038 60.829 153.501 61.1864 153.3C62.7043 152.444 65.8313 150.524 67.4529 148.393C68.9521 146.423 70.3142 142.762 71.0256 140.644Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8608 157.639C50.0291 157.168 50.7629 157.168 50.9312 157.639C51.3876 158.915 52.0892 160.64 52.8496 161.639C53.7117 162.772 55.2832 163.806 56.263 164.383C56.6164 164.591 56.6164 165.136 56.263 165.344C55.2832 165.921 53.7117 166.955 52.8496 168.088C52.0892 169.087 51.3876 170.812 50.9312 172.088C50.7629 172.559 50.0291 172.559 49.8608 172.088C49.4044 170.812 48.7028 169.087 47.9424 168.088C47.0803 166.955 45.5088 165.921 44.529 165.344C44.1756 165.136 44.1756 164.591 44.529 164.383C45.5088 163.806 47.0803 162.772 47.9424 161.639C48.7028 160.64 49.4044 158.915 49.8608 157.639Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_31409_1062",
    x: 46.7969,
    y: 33.0703,
    width: 116.639,
    height: 161.784,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_31409_1062"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_31409_1062",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_31409_1062",
    x: 122.863,
    y: 128.337,
    width: 75.4288,
    height: 74.9495,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_31409_1062"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_31409_1062",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_31409_1062",
    x1: 107.116,
    y1: 48.7471,
    x2: 107.116,
    y2: 184.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C8FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98E2EB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_31409_1062",
    x1: 107.632,
    y1: 84.9375,
    x2: 107.632,
    y2: 148.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAAACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81B4F7"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgThanksAllSet);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/thanks_AllSet.1ce87aa8.svg";